import React, {useEffect, useState} from 'react'
import {Box, CircularProgress, Stack, Typography} from "@mui/material"
import {useProjectData} from "../../hooks/useProjectData"
import {ProjectRequests} from "../../api/requests/ProjectRequests"
import {AnyActivityJson} from "../../api/json/AnyActivityJson"
import ActivityCard from "../activities/ActivityCard/ActivityCard"
import ApiError from "../../api/ApiError"
import ErrorMessage from "../error/ErrorMessage"
import animations from "../../Animations.module.scss"

function ActivitySidebar() {
    const {id} = useProjectData()

    const [activities, setActivities] = useState<AnyActivityJson[]>()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<ApiError>()

    useEffect(() => {
        if (!id) return
        setLoading(true)
        ProjectRequests.listActivities(id)
            .then(page => setActivities(page.content))
            .catch(setError)
            .finally(() => setLoading(false))
    }, [id])

    return (
        <Box>
            <Typography variant="subtitle1">Project Activity</Typography>
            <Stack spacing={3} className={animations.defaultIn} sx={{mt: 2}}>
                {loading && <CircularProgress size={24}/>}
                {activities && activities.map(activity =>
                    <ActivityCard key={activity.id} activity={activity} projectContext/>,
                )}
                {error && <ErrorMessage error={error}/>}
            </Stack>
        </Box>
    )
}

export default ActivitySidebar
